import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';

const Dashboard = () => {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="p-6">
        {/* Welcome Section */}
        <h1 className="text-3xl font-bold text-base-content mb-6">
          Welcome to StockAlgoTrader
        </h1>

        {/* Dashboard Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title text-primary">📈 Trading</h2>
              <p className="text-base-content/70">View and manage your active trades</p>
              <div className="card-actions justify-end">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate('/dashboard/live-trading')}
                >
                  View Trades
                </button>
              </div>
            </div>
          </div>

          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title text-secondary">🔗 Brokers</h2>
              <p className="text-base-content/70">Connect and manage your broker accounts</p>
              <div className="card-actions justify-end">
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => navigate('/dashboard/brokers')}
                >
                  Manage Brokers
                </button>
              </div>
            </div>
          </div>

          <div className="card bg-base-100 shadow-xl">
            <div className="card-body">
              <h2 className="card-title text-accent">⚡ Strategies</h2>
              <p className="text-base-content/70">Create and deploy trading strategies</p>
              <div className="card-actions justify-end">
                <button
                  className="btn btn-accent btn-sm"
                  onClick={() => navigate('/dashboard/strategies')}
                >
                  View Strategies
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;